var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import aopOrderBookDI from "./di/servicelocator";
import { Overlay, Popover, Spinner } from "react-bootstrap";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/AOP Investment/AOP_Investment.scss";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericStatus from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import emptyFolder from "@frameworks/shared-library/assets/images/markets/emptyFolder.svg";
import viewDetails from "@frameworks/shared-library/assets/images/SalesJourney/view-details.svg";
import AOPSidebar from "./AOP_Investment_Sidebar";
import autheticate from "@frameworks/shared-library/assets/images/SalesJourney/autheticate.svg";
import esignLink from "@frameworks/shared-library/assets/images/SalesJourney/send-esign-link.svg";
import selfieLink from "@frameworks/shared-library/assets/images/SalesJourney/send-selfie-link.svg";
import { useSelector } from "react-redux";
import successIcon from "@frameworks/shared-library/assets/images/SalesJourney/success-circular-icon.svg";
import failureIcon from "@frameworks/shared-library/assets/images/SalesJourney/failure-icon.svg";
import Toasts from "@frameworks/shared-library/components/Toast/Toast";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
var AOPInvestment = function (props) {
    var _a;
    var _b = __read(React.useState((props === null || props === void 0 ? void 0 : props.loader) ? props === null || props === void 0 ? void 0 : props.loader : false), 2), loader = _b[0], setLoader = _b[1];
    var _c = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), verificationLinkToastDetails = _c[0], setVerificationLinkToastDetails = _c[1];
    var _d = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), selfieToastDetails = _d[0], setSelfieToastDetails = _d[1];
    var _e = __read(React.useState(false), 2), sideBar = _e[0], setSideBar = _e[1];
    var _f = __read(React.useState(props === null || props === void 0 ? void 0 : props.data), 2), tableData = _f[0], setTableData = _f[1];
    var _g = __read(React.useState(null), 2), selectedRowObj = _g[0], setSelectedRowObj = _g[1];
    var _h = __read(React.useState(false), 2), overlaySpinner = _h[0], setOverlaySpinner = _h[1];
    var _j = __read(useState(""), 2), trxId = _j[0], setTrxId = _j[1];
    var orderbookRef = React.useRef(null);
    var _k = __read(React.useState({
        isShowPopup: false,
        containerId: "",
    }), 2), tableRowActionPopupConfig = _k[0], setTableRowActionPopupConfig = _k[1];
    var _l = __read(React.useState({
        page: 0,
        totalPages: (props === null || props === void 0 ? void 0 : props.totalPages)
            ? props === null || props === void 0 ? void 0 : props.totalPages
            : Math.ceil(props.data.length / 10),
        nextPage: 1,
    }), 2), pageObj = _l[0], setPageObj = _l[1];
    var profileData = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.Profile) === null || _a === void 0 ? void 0 : _a.ProfileDetails) === null || _b === void 0 ? void 0 : _b.reducersData) === null || _c === void 0 ? void 0 : _c.data; });
    var setAOPTotalPage = function () {
        var _a, _b, _c, _d;
        setLoader(true);
        if (((_a = props === null || props === void 0 ? void 0 : props.filterData) === null || _a === void 0 ? void 0 : _a.inputEmpId) == null ||
            ((_b = props === null || props === void 0 ? void 0 : props.filterData) === null || _b === void 0 ? void 0 : _b.inputEmpId) == undefined) {
            props.filterData.inputEmpId = [];
        }
        props === null || props === void 0 ? void 0 : props.filterData.inputEmpId.push((_d = (_c = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _c === void 0 ? void 0 : _c.userId) === null || _d === void 0 ? void 0 : _d.toString());
        var newSet = new Set(props === null || props === void 0 ? void 0 : props.filterData.inputEmpId);
        props.filterData.inputEmpId = __spreadArray([], __read(newSet), false);
        var reqObj = props === null || props === void 0 ? void 0 : props.filterData;
        reqObj.encryption = true;
        aopOrderBookDI.aopOrderBook
            .getAopOrderbookDashboard(reqObj)
            .then(function (resp) {
            var _a;
            if (!!resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.orderBookList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                if ((props === null || props === void 0 ? void 0 : props.totalPages) == undefined || (props === null || props === void 0 ? void 0 : props.totalPages) == null) {
                    setPageObj(function (pageObj) {
                        pageObj.totalPages = resp === null || resp === void 0 ? void 0 : resp.totalRecord;
                        return pageObj;
                    });
                }
                setLoader(false);
            }
            else {
                setLoader(false);
            }
        })
            .catch(function (resp) {
            setLoader(false);
        });
    };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.totalPages) == undefined || (props === null || props === void 0 ? void 0 : props.totalPages) == null)
            setAOPTotalPage();
    }, []);
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.totalPages) !== undefined &&
            (props === null || props === void 0 ? void 0 : props.totalPages) !== null &&
            (props === null || props === void 0 ? void 0 : props.totalPages) > 0) {
            setPageObj(function (pageObj) {
                pageObj.totalPages = props === null || props === void 0 ? void 0 : props.totalPages;
                return pageObj;
            });
        }
        //setAOPTotalPage();
    }, [props === null || props === void 0 ? void 0 : props.totalPages]);
    var generateSchemeName = function (keys, keysForCustomFunction) {
        var _a;
        return (React.createElement("div", { className: "d-flex align-item-center gap-2" },
            React.createElement("div", { className: "read-more-tooltip align-items-center" }, !!keys[0] &&
                keys[0] !== undefined &&
                keys[0] !== "" &&
                keys[0] !== " " ? (React.createElement(GenericSchemeName, { name: keys[0], subText1: (_a = keys[1]) === null || _a === void 0 ? void 0 : _a.slice(0, -1), 
                //  subText2={keys[2]}
                maxWidth: 235, subText1className: "aop_investment_account_code_color", 
                //showTooltip
                showImage: true })) : (React.createElement(React.Fragment, null, "-")))));
    };
    var showFooter = function () {
        return false;
    };
    var generateDate = function (displayData) {
        var splitArr = displayData.split(" ");
        var date = splitArr.slice(0, 3).join(" ");
        var time = splitArr.slice(3).join(" ");
        return displayData ? (React.createElement("div", { className: "d-flex flex-column gap-1 text-right text-end table-columns-date-color" },
            React.createElement("label", null, date),
            React.createElement("label", null, time))) : ("-");
    };
    var sendSelfieLink = function () {
        setSelfieToastDetails({ isShow: false, isError: false, msg: "" });
        setOverlaySpinner(true);
        var reqObj = {
            applicationId: selectedRowObj === null || selectedRowObj === void 0 ? void 0 : selectedRowObj.accountCode,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAopOrderbookSelfieLink(reqObj)
            .then(function (resp) {
            setSelfieToastDetails({
                isShow: true,
                isError: false,
                msg: "Selfie link has been successfully sent.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            // setShowPopupMenu(false);
            setOverlaySpinner(false);
            handleCloseOverlay();
        })
            .catch(function (resp) {
            setSelfieToastDetails({
                isShow: true,
                isError: false,
                msg: "Oops! there was an error sending the selfie link.Please try again later.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            // setShowPopupMenu(false);
            setOverlaySpinner(false);
            handleCloseOverlay();
        });
    };
    var sendVerificationLink = function () {
        setVerificationLinkToastDetails({ isShow: false, isError: false, msg: "" });
        setOverlaySpinner(true);
        var reqObj = {
            applicationId: selectedRowObj === null || selectedRowObj === void 0 ? void 0 : selectedRowObj.accountCode,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAopOrderbookVerificationLink(reqObj)
            .then(function (resp) {
            setVerificationLinkToastDetails({
                isShow: true,
                isError: false,
                msg: "Verification link has been successfully sent.",
            });
            handleCloseOverlay();
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setOverlaySpinner(false);
        })
            .catch(function (resp) {
            setVerificationLinkToastDetails({
                isShow: true,
                isError: false,
                msg: "Oops! there was an error sending the Verification link.Please try again later.",
            });
            handleCloseOverlay();
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setOverlaySpinner(false);
        });
    };
    var generateStatus = function (statusText, statusType) {
        return (React.createElement(GenericStatus, { statusText: capitalizeFirstLetter(statusText), statusType: statusType, parentClassName: "DMsanL_15_300" }));
    };
    var generateTableRowActionPopup = function (transactionId) {
        return (React.createElement("span", { id: transactionId, className: "edel-icon-kabab-menu mf-transactions-row-actions-wrapper ".concat(trxId === transactionId ? "active-menu" : ""), onClick: function (e) {
                var _a;
                e.stopPropagation();
                var accountFound = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.find(function (record) { return record && (record === null || record === void 0 ? void 0 : record.accountCode) == transactionId; });
                if (!!accountFound) {
                    setSelectedRowObj(accountFound);
                }
                setTrxId(transactionId);
                setTableRowActionPopupConfig({
                    isShowPopup: true,
                    containerId: transactionId,
                });
            } }));
    };
    var fundColumns = [
        {
            columnName: "Client Name",
            //  key: "clientName",
            key3: "clientName",
            sortKey: "clientName",
            type: "string",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            keysForCustomFunction: ["clientName", "accountCode"],
            tdCustomFunction: function (keys) {
                return generateSchemeName(keys, this.keysForCustomFunction);
            },
        },
        {
            columnName: "Lead Id",
            key: "leadId",
            key3: "leadId",
            sortKey: "leadId",
            columnClassName: "text-left table-columns-lead-color",
            type: "string",
            arrows: true,
            applySorting: true,
            //      columnClassName: "text-end",
        },
        {
            columnName: "Client Entity",
            key: "clientEntity",
            key3: "clientEntity",
            type: "string",
            sortKey: "clientEntity",
            columnClassName: "text-left table-columns-client-color",
            arrows: true,
            applySorting: true,
            //  tdCustomFunction: yearValue,
        },
        {
            columnName: "KYC Status",
            key: "kycStatus",
            //    key2: "schemeCode",
            key3: "kycStatus",
            sortKey: "kycStatus",
            arrows: false,
            columnClassName: "text-left table-columns-kycstatus-color",
            // columnClassName: "text-end",
            // arrowClassName: "text-right",
            applySorting: false,
            //     tdCustomFunction: yearValue,
        },
        {
            columnName: "Date",
            key: "dateTime",
            key3: "dateTime",
            type: "Date",
            arrows: true,
            applySorting: true,
            sortKey: "dateTime",
            arrowClassName: "justify-content-end",
            //   columnClassName: "text-right table-columns-date-color",
            tdCustomFunction: generateDate,
        },
        {
            columnName: "Status",
            arrows: false,
            applySorting: false,
            sortKey: "displayStatus",
            type: "string",
            keysForCustomFunction: ["displayStatus", "status"],
            tdCustomFunction: function (keys) {
                return (React.createElement(React.Fragment, null, keys[0] !== "-"
                    ? generateStatus(keys[0], keys[1])
                    : "-"));
            },
        },
        {
            columnName: "",
            key: "accountCode",
            tdCustomFunction: function (key) { return generateTableRowActionPopup(key); },
        },
    ];
    var generateDefaultError = function () {
        return (React.createElement("div", { className: "custom-error-state flexCenter" },
            React.createElement(Errormsg, { image: emptyFolder, msg: "No results found" })));
    };
    var calculatePage = function (page) {
        setPageObj(function (pageObj) {
            pageObj.page = page;
            pageObj.nextPage = pageObj.page + 1;
            return pageObj;
        });
        props === null || props === void 0 ? void 0 : props.setFilterData(function (filterData) {
            var _a;
            filterData.pageStart = 0;
            filterData.pageSize = ((_a = props === null || props === void 0 ? void 0 : props.filterData) === null || _a === void 0 ? void 0 : _a.pageSize) + 10;
            if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == undefined) {
                filterData.inputEmpId = [];
            }
            var newSet = new Set(filterData.inputEmpId);
            filterData.inputEmpId = __spreadArray([], __read(newSet), false);
            props === null || props === void 0 ? void 0 : props.getAOPDashboardData(filterData);
            return filterData;
        });
    };
    React.useEffect(function () {
        var _a;
        if ((props === null || props === void 0 ? void 0 : props.data) && ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setTableData(props === null || props === void 0 ? void 0 : props.data);
        }
    }, [props === null || props === void 0 ? void 0 : props.searchFilterApplied, props === null || props === void 0 ? void 0 : props.data]);
    var getCustomLoadMore = function () {
        var _a;
        var customLodeMore = false;
        if (!!(props === null || props === void 0 ? void 0 : props.searchFilterApplied) &&
            (props === null || props === void 0 ? void 0 : props.searchFilterApplied) &&
            ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 10) {
            customLodeMore = true;
        }
        else {
            if (!!(props === null || props === void 0 ? void 0 : props.searchFilterApplied) && (props === null || props === void 0 ? void 0 : props.searchFilterApplied)) {
                customLodeMore = false;
            }
            else {
                if ((pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalPages) > 10) {
                    customLodeMore = true;
                }
                else if ((tableData === null || tableData === void 0 ? void 0 : tableData.length) > 10) {
                    customLodeMore = true;
                }
            }
        }
        return customLodeMore;
    };
    var getMannualText = function () {
        var condition = false;
        if ((props === null || props === void 0 ? void 0 : props.totalPages) == undefined || (props === null || props === void 0 ? void 0 : props.totalPages) == null) {
            setPageObj(function (pageObj) {
                if (pageObj.totalPages > pageObj.page + 1)
                    condition = true;
                return pageObj;
            });
        }
        else {
            if ((props === null || props === void 0 ? void 0 : props.totalPages) > pageObj.page + 1)
                condition = true;
        }
        return condition;
    };
    var sendEsignLink = function () {
        setOverlaySpinner(true);
        aopOrderBookDI.aopOrderBook
            .getAopOrderBookESignLink({ applicationId: trxId })
            .then(function (resp) {
            handleCloseOverlay();
            setOverlaySpinner(false);
        })
            .catch(function (resp) {
            handleCloseOverlay();
            setOverlaySpinner(false);
        });
    };
    var handleCloseOverlay = function () {
        setTrxId("");
        setTableRowActionPopupConfig({ isShowPopup: false, containerId: "" });
    };
    return (React.createElement(React.Fragment, null,
        selfieToastDetails && (React.createElement(Toasts, { show: selfieToastDetails.isShow, setShow: function (val) {
                setSelfieToastDetails({
                    isShow: val,
                    isError: false,
                    msg: "",
                });
            }, position: "top-center", 
            // message={toastDetails.msg}
            customMessage: React.createElement(React.Fragment, null,
                React.createElement("span", { className: "d-flex justify-content-between" },
                    React.createElement("span", { className: "d-flex" },
                        React.createElement("img", { src: selfieToastDetails.isError ? failureIcon : successIcon }),
                        React.createElement("label", { className: "toast-custom-label" }, selfieToastDetails === null || selfieToastDetails === void 0 ? void 0 : selfieToastDetails.msg)),
                    React.createElement("div", { className: "edel-icon" },
                        React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () {
                                return setSelfieToastDetails({
                                    isShow: false,
                                    isError: false,
                                    msg: "",
                                });
                            } })))), delay: 3000, parentClass: "sidebar-toast-container ".concat(selfieToastDetails.isError ? "error-toast" : "success-toast") })),
        verificationLinkToastDetails && (React.createElement(Toasts, { show: verificationLinkToastDetails.isShow, setShow: function (val) {
                setVerificationLinkToastDetails({
                    isShow: val,
                    isError: false,
                    msg: "",
                });
            }, position: "top-center", 
            // message={toastDetails.msg}
            customMessage: React.createElement(React.Fragment, null,
                React.createElement("span", { className: "d-flex justify-content-between" },
                    React.createElement("span", { className: "d-flex" },
                        React.createElement("img", { src: verificationLinkToastDetails.isError
                                ? failureIcon
                                : successIcon }),
                        React.createElement("label", { className: "toast-custom-label" }, verificationLinkToastDetails === null || verificationLinkToastDetails === void 0 ? void 0 : verificationLinkToastDetails.msg)),
                    React.createElement("div", { className: "edel-icon" },
                        React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () {
                                return setVerificationLinkToastDetails({
                                    isShow: false,
                                    isError: false,
                                    msg: "",
                                });
                            } })))), delay: 3000, parentClass: "sidebar-toast-container ".concat(selfieToastDetails.isError ? "error-toast" : "success-toast") })),
        tableRowActionPopupConfig.isShowPopup && (React.createElement(Overlay, { show: tableRowActionPopupConfig.isShowPopup, target: document.getElementById(tableRowActionPopupConfig.containerId), rootClose: true, onHide: function () {
                handleCloseOverlay();
            }, placement: "bottom-end", container: orderbookRef },
            React.createElement(Popover, { id: "popover-contained", className: "table-actions-without-generic-popup-container removePopupTooltipArrow" },
                React.createElement(Popover.Body, null,
                    React.createElement("div", { className: "table-actions-internal-list-wrapper flex-column flexCenter" }, overlaySpinner ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10" },
                            React.createElement(Spinner, { animation: "border", variant: "primary", className: "txt_tomatoRed" })))) : (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: "esign", tabIndex: 0, onClick: function (e) {
                                if (sideBar !== null && sideBar != undefined) {
                                    setSideBar(!sideBar);
                                    handleCloseOverlay();
                                }
                            } },
                            React.createElement("img", { src: viewDetails }),
                            React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, "View Details")),
                        (selectedRowObj === null || selectedRowObj === void 0 ? void 0 : selectedRowObj.selfieLinkBtn) && (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: "esign", tabIndex: 0, onClick: function (e) {
                                sendSelfieLink();
                            } },
                            React.createElement(React.Fragment, null,
                                React.createElement("img", { src: selfieLink })),
                            React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, "Send Selfie Link"))),
                        (selectedRowObj === null || selectedRowObj === void 0 ? void 0 : selectedRowObj.authLinkBtn) && (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: "esign", tabIndex: 0, onClick: function (e) {
                                sendVerificationLink();
                            } },
                            (selectedRowObj === null || selectedRowObj === void 0 ? void 0 : selectedRowObj.kycStatus) === "KRA" ? (React.createElement(React.Fragment, null,
                                React.createElement("img", { src: autheticate }))) : (React.createElement(React.Fragment, null,
                                React.createElement("img", { src: esignLink }))),
                            React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, (selectedRowObj === null || selectedRowObj === void 0 ? void 0 : selectedRowObj.kycStatus) == "KRA"
                                ? "Send Authentication Link"
                                : "Send Esign Link")))))))))),
        ((!!(props === null || props === void 0 ? void 0 : props.loader) && (props === null || props === void 0 ? void 0 : props.loader)) || loader) && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 8, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1-1-1_2" })),
        React.createElement("div", { className: "aop_investment w-100", ref: orderbookRef },
            !!(props === null || props === void 0 ? void 0 : props.data) && (props === null || props === void 0 ? void 0 : props.data.length) > 0 && (pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalPages) > 0 && (React.createElement(DynamicPagination, { dataLengthPerPage: 10, data: (props === null || props === void 0 ? void 0 : props.data) ? props === null || props === void 0 ? void 0 : props.data : [], rowClassName: "bg_aqua_white hand_cursor", columns: fundColumns, parentClassName: "table common-table-border common-compact-table-wrapper", infinityScroll: true, customLoadMore: getCustomLoadMore(), manualNext: getMannualText(), nextFunction: calculatePage, totalNumberPages: Math.ceil((pageObj === null || pageObj === void 0 ? void 0 : pageObj.totalPages) / 10), paginationLoader: loader, initPageNumber: 1, rowOnClick: function (resp) {
                    if (!!resp && resp) {
                        setSelectedRowObj(resp);
                        if (sideBar !== null && sideBar != undefined)
                            setSideBar(!sideBar);
                    }
                }, 
                // callbackSorted={onSortToggleClick}
                sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: props.viewAll })),
            (props === null || props === void 0 ? void 0 : props.data) == null ||
                (props === null || props === void 0 ? void 0 : props.data) == undefined ||
                (((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) == 0 && generateDefaultError()),
            sideBar && (React.createElement(AOPSidebar, { sideBar: sideBar, setSideBar: setSideBar, selectedRowObj: selectedRowObj })))));
};
export default AOPInvestment;
